import Logo from "../images/FitnessTrackrLogo.png";
import runner from "../images/runner.png";
import biking from "../images/biking.png";
import swimming from "../images/swimming.png";
import yoga from "../images/yoga.png";
import elliptical from "../images/elliptical.png";
import scale from "../images/scale.png";
import muscles from "../images/muscles.png";
import abs from "../images/abs.png";
import flex from "../images/flex.png";
import stretch from "../images/stretch.png";

export default {
  Logo,
  runner,
  biking,
  swimming,
  yoga,
  elliptical,
  scale,
  muscles,
  abs,
  flex,
  stretch,
};
